import { api, getSyncInfo } from "../services/storage.js";
import { getLanguage, locale } from "../core/i18n.js";
import { esc } from "../core/model.js";
import { icon } from "./icons.js";

const copy = {
  title: ["Owner markazi", "Owner overview", "Панель владельца"],
  intro: [
    "Saytingizdagi faollik. Hammasi bir joyda.",
    "Your site's activity. All in one place.",
    "Активность сайта. Всё в одном месте.",
  ],
  private: ["Faqat siz uchun", "Only for you", "Только для вас"],
  live: ["Jonli kuzatuv", "Live activity", "Живая активность"],
  refresh: ["Yangilash", "Refresh", "Обновить"],
  updated: ["Yangilandi", "Updated", "Обновлено"],
  online: ["Hozir online", "Online now", "Сейчас онлайн"],
  guests: ["mehmon", "guests", "гостей"],
  today: ["Bugungi kirishlar", "Visits today", "Визиты сегодня"],
  timezone: [
    "Toshkent vaqti · 00:00 dan",
    "Tashkent time · since 00:00",
    "Ташкентское время · с 00:00",
  ],
  accounts: ["Foydalanuvchilar", "Users", "Пользователи"],
  accountCount: ["foydalanuvchi", "users", "пользователей"],
  registered: [
    "Ro‘yxatdan o‘tgan akkauntlar",
    "Registered accounts",
    "Зарегистрированные аккаунты",
  ],
  newReports: ["Yangi reportlar", "New reports", "Новые обращения"],
  waiting: [
    "Ko‘rib chiqishni kutmoqda",
    "Waiting for review",
    "Ожидают рассмотрения",
  ],
  peopleIntro: [
    "Kim online va oxirgi marta qachon kirgan?",
    "Who's online and when did they last visit?",
    "Кто онлайн и когда заходил?",
  ],
  all: ["Barchasi", "All", "Все"],
  onlineOnly: ["Online", "Online", "Онлайн"],
  search: ["Email orqali qidirish", "Search by email", "Поиск по email"],
  person: ["Foydalanuvchi", "User", "Пользователь"],
  state: ["Holat", "Status", "Статус"],
  entry: ["Oxirgi kirish", "Last visit", "Последний визит"],
  seen: ["Oxirgi faollik", "Last active", "Последняя активность"],
  offline: ["Offline", "Offline", "Не в сети"],
  unknown: ["Hali qayd etilmagan", "Not recorded yet", "Пока не зафиксировано"],
  noneUsers: [
    "Foydalanuvchi topilmadi",
    "No users found",
    "Пользователи не найдены",
  ],
  prev: ["Oldingi", "Previous", "Назад"],
  next: ["Keyingi", "Next", "Далее"],
  reports: ["Reportlar", "Reports", "Обращения"],
  reportIntro: [
    "Muammo, taklif va fikrlarni ko‘rib chiqing.",
    "Review issues, suggestions and feedback.",
    "Проблемы, предложения и отзывы.",
  ],
  open: ["Yangi", "New", "Новое"],
  reviewed: ["Ko‘rib chiqildi", "Reviewed", "Рассмотрено"],
  resolved: ["Hal qilindi", "Resolved", "Решено"],
  searchReports: [
    "Report yoki emailni qidirish",
    "Search reports or email",
    "Поиск обращений или email",
  ],
  noneReports: ["Report topilmadi", "No reports found", "Обращений не найдено"],
  reportEmpty: [
    "Foydalanuvchilar yuborgan reportlar shu yerda ko‘rinadi.",
    "User reports will appear here.",
    "Здесь появятся обращения пользователей.",
  ],
  more: ["Yana ko‘rsatish", "Load more", "Показать ещё"],
  history: ["Kirishlar tarixi", "Visit history", "История визитов"],
  historyIntro: [
    "Kim, qachon va qanday kirgan — vaqt tartibida.",
    "Who visited, when and how — in time order.",
    "Кто, когда и как заходил — по времени.",
  ],
  guest: ["Mehmon", "Guest", "Гость"],
  visit: ["Saytga kirdi", "Visited the site", "Открыл сайт"],
  return: ["Sessiyani davom ettirdi", "Resumed a session", "Продолжил сеанс"],
  login: ["Parol bilan kirdi", "Signed in with password", "Вход по паролю"],
  register: ["Ro‘yxatdan o‘tdi", "Created an account", "Создал аккаунт"],
  google: ["Google orqali kirdi", "Signed in with Google", "Вход через Google"],
  code: [
    "Email kodi bilan kirdi",
    "Signed in with an email code",
    "Вход по коду из письма",
  ],
  link: ["Google akkauntini uladi", "Connected Google", "Подключил Google"],
  noneHistory: [
    "Kirishlar hali qayd etilmagan",
    "No visits recorded yet",
    "Визитов пока нет",
  ],
  note: [
    "Online: oxirgi 90 soniyada ochiq sahifadan signal kelgan. Mehmonlar alohida hisoblanadi. Yangi kirishlar shu versiyadan boshlab qayd etiladi. Barcha vaqtlar Toshkent vaqti (UTC+5).",
    "Online means a visible page sent a signal in the last 90 seconds. Guests are counted separately. Visit history starts with this version. All times are Tashkent time (UTC+5).",
    "Онлайн: открытая страница отправила сигнал за последние 90 секунд. Гости учитываются отдельно. История ведётся с этой версии. Время — Ташкент (UTC+5).",
  ],
  denied: [
    "Bu sahifa faqat sayt egasi uchun",
    "This page is only for the site owner",
    "Эта страница только для владельца сайта",
  ],
  deniedIntro: [
    "Owner akkauntingiz bilan tizimga kiring.",
    "Sign in with your owner account.",
    "Войдите в аккаунт владельца.",
  ],
  signIn: ["Tizimga kirish", "Sign in", "Войти"],
  back: ["Rejalarga qaytish", "Back to planner", "Вернуться к планам"],
  loading: ["Yuklanmoqda…", "Loading…", "Загрузка…"],
  error: [
    "Ma’lumot yuklanmadi. Yangilash tugmasini bosing.",
    "Could not load data. Use Refresh to try again.",
    "Не удалось загрузить данные. Нажмите «Обновить».",
  ],
  saveError: [
    "Report holati saqlanmadi. Qayta urinib ko‘ring.",
    "Could not save the report status. Try again.",
    "Не удалось сохранить статус. Повторите попытку.",
  ],
  saved: ["Report holati saqlandi", "Report status saved", "Статус сохранён"],
};
const text = (key) =>
  copy[key]?.[{ uz: 0, en: 1, ru: 2 }[getLanguage()]] || key;
const stamp = (value) =>
  value
    ? new Intl.DateTimeFormat(locale(), {
        timeZone: "Asia/Tashkent",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      }).format(new Date(value))
    : text("unknown");
const clock = (value) =>
  new Intl.DateTimeFormat(locale(), {
    timeZone: "Asia/Tashkent",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).format(new Date(value));
export const isOwner = () =>
  !getSyncInfo().requiresLogin &&
  !!getSyncInfo().session?.user?.canReviewReports;
let dispose = () => {};
export function disposeOwner() {
  dispose();
}

export function renderOwner() {
  if (!isOwner())
    return `<section class="owner-denied">${icon("owner")}<h1>${text("denied")}</h1><p>${text("deniedIntro")}</p><div><a class="btn black" href="/login">${text("signIn")}</a><button class="btn" data-page="today">${text("back")}</button></div></section>`;
  return `<div class="owner-page">
    <header class="owner-header"><div><span class="owner-kicker">DAYX / OWNER</span><h1>${text("title")}</h1><p>${text("intro")}</p></div><span class="owner-private">${icon("owner")}${text("private")}</span></header>
    <section class="owner-livebar"><div><span class="owner-dot"></span><strong>${text("live")}</strong><span data-owner-updated>${text("loading")}</span></div><button class="btn" data-owner-refresh>${icon("reset")}${text("refresh")}</button></section>
    <p class="owner-error" data-owner-error role="alert" hidden></p>
    <div class="owner-metrics">${[
      ["online", "people", "guests"],
      ["today", "clock", "timezone"],
      ["users", "people", "registered"],
      ["openReports", "report", "waiting"],
    ]
      .map(
        ([key, glyph, note], index) =>
          `<article class="owner-metric ${index === 0 ? "owner-metric-dark" : ""}"><div><span>${text(index === 2 ? "accounts" : index === 3 ? "newReports" : key)}</span>${icon(glyph)}</div><strong data-metric="${key}">—</strong><small data-metric-note="${key}">${index === 0 ? "—" : text(note)}</small></article>`,
      )
      .join("")}</div>
    <div class="owner-columns"><section class="owner-panel owner-people"><header class="owner-panel-head"><div><h2>${text("accounts")} <span data-user-total></span></h2><p>${text("peopleIntro")}</p></div>${icon("people")}</header>
      <div class="owner-people-tools"><div class="owner-segment" aria-label="${text("state")}"><button data-people-filter="all" aria-pressed="true">${text("all")}</button><button data-people-filter="online" aria-pressed="false"><span class="owner-dot"></span>${text("onlineOnly")}</button></div><label class="owner-search">${icon("search")}<input type="search" data-people-search placeholder="${text("search")}" aria-label="${text("search")}" maxlength="254"></label></div>
      <div class="owner-table-wrap"><table class="owner-table"><thead><tr>${["person", "state", "entry", "seen"].map((key) => `<th scope="col">${text(key)}</th>`).join("")}</tr></thead><tbody data-people-list><tr><td colspan="4" class="owner-empty">${text("loading")}</td></tr></tbody></table></div><footer class="owner-pagination"><span data-people-page></span><div><button class="btn" data-people-prev disabled>${text("prev")}</button><button class="btn" data-people-next disabled>${text("next")}</button></div></footer>
    </section><section class="owner-panel owner-reports"><header class="owner-panel-head"><div><h2>${text("reports")} <span data-reports-total></span></h2><p>${text("reportIntro")}</p></div>${icon("report")}</header><div class="owner-report-tools"><label class="owner-search">${icon("search")}<input type="search" data-reports-search placeholder="${text("searchReports")}" aria-label="${text("searchReports")}" maxlength="254"></label><select class="field" data-reports-filter aria-label="${text("state")}">${["all", "open", "reviewed", "resolved"].map((key) => `<option value="${key === "all" ? "" : key}">${text(key)}</option>`).join("")}</select></div><p class="owner-error" data-reports-error role="alert" hidden></p><p class="owner-feedback" data-reports-feedback role="status"></p><div class="owner-report-list" data-reports-list>${empty("loading", "report")}</div><button class="btn owner-more" data-reports-more hidden>${text("more")}</button></section></div>
    <section class="owner-panel owner-history"><header class="owner-panel-head"><div><span class="owner-kicker">ACTIVITY LOG</span><h2>${text("history")}</h2><p>${text("historyIntro")}</p></div>${icon("clock")}</header><p class="owner-error" data-history-error role="alert" hidden></p><ol class="owner-history-list" data-history-list><li>${empty("loading", "clock")}</li></ol><button class="btn owner-more" data-history-more hidden>${text("more")}</button></section><p class="owner-note">${icon("owner")}<span>${text("note")}</span></p>
  </div>`;
}
function empty(key, glyph, sub = "") {
  return `<div class="owner-empty">${icon(glyph)}<strong>${text(key)}</strong>${sub ? `<p>${text(sub)}</p>` : ""}</div>`;
}

export function mountOwner() {
  dispose();
  const root = document.querySelector(".owner-page");
  if (!root || !isOwner()) return;
  const controller = new AbortController();
  let peoplePage = 1,
    peopleOnline = false,
    reports = [],
    reportNext = null,
    reportExpanded = false,
    visits = [],
    visitNext = null;
  let peopleVersion = 0,
    reportVersion = 0,
    peopleDebounce,
    reportDebounce,
    reportBusy = false,
    historyBusy = false;
  const find = (selector) => root.querySelector(selector);
  const request = (path, options = {}) =>
    api(path, { ...options, signal: controller.signal });
  function error(selector, key = "") {
    const el = find(selector);
    el.hidden = !key;
    el.textContent = key ? text(key) : "";
  }
  async function loadPeople() {
    const version = ++peopleVersion;
    find(".owner-people").setAttribute("aria-busy", "true");
    try {
      const params = new URLSearchParams({
        page: peoplePage,
        q: find("[data-people-search]").value,
        online: peopleOnline ? "1" : "0",
      });
      const result = await request(`/api/owner?${params}`);
      if (version !== peopleVersion || !root.isConnected) return;
      error("[data-owner-error]");
      for (const [key, value] of Object.entries(result.summary)) {
        const metric = find(`[data-metric="${key}"]`);
        if (metric) metric.textContent = value.toLocaleString(locale());
      }
      find('[data-metric-note="online"]').textContent =
        `${result.summary.online - result.summary.guests} ${text("accountCount")} · ${result.summary.guests} ${text("guests")}`;
      find("[data-owner-updated]").textContent =
        `${text("updated")} ${clock(result.updatedAt)}`;
      find("[data-user-total]").textContent = result.total;
      find("[data-people-list]").innerHTML = result.users.length
        ? result.users
            .map(
              (user) =>
                `<tr><td><div class="owner-person"><span class="owner-avatar">${esc(user.email[0].toUpperCase())}</span><div><strong>${esc(user.email)}</strong><button type="button" class="owner-user-reports" data-user-reports="${esc(user.email)}">${text("reports")} · ${user.reports}</button></div></div></td><td><span class="owner-presence ${user.online ? "is-online" : ""}"><i></i>${text(user.online ? "onlineOnly" : "offline")}</span>${user.page ? `<small class="owner-current-page">${esc(user.page)}</small>` : ""}</td><td><time>${stamp(user.lastEntry)}</time></td><td><time>${stamp(user.lastSeen)}</time></td></tr>`,
            )
            .join("")
        : `<tr><td colspan="4">${empty("noneUsers", "search")}</td></tr>`;
      find("[data-people-page]").textContent =
        `${result.page} / ${result.pages}`;
      find("[data-people-prev]").disabled = peoplePage <= 1;
      find("[data-people-next]").disabled = peoplePage >= result.pages;
    } catch (failure) {
      if (!controller.signal.aborted && version === peopleVersion)
        error("[data-owner-error]", "error");
    } finally {
      if (version === peopleVersion)
        find(".owner-people").removeAttribute("aria-busy");
    }
  }
  function drawReports() {
    const opened = new Set(
      [...root.querySelectorAll("[data-owner-report][open]")].map(
        (el) => el.dataset.ownerReport,
      ),
    );
    find("[data-reports-list]").innerHTML = reports.length
      ? reports
          .map(
            (row) =>
              `<details class="owner-report" data-owner-report="${row.id}" ${opened.has(row.id) ? "open" : ""}><summary><div class="owner-report-meta"><span class="owner-status" data-status="${row.status}">${text(row.status)}</span><time>${stamp(row.createdAt)}</time></div><h3>${esc(row.subject)}</h3><span class="owner-report-sender">${esc(row.email)}</span><p>${esc(row.description)}</p><span class="owner-report-chevron">${icon("chevron")}</span></summary><div class="owner-report-detail"><p>${esc(row.description)}</p><div class="owner-report-context"><span>${esc(row.page)}</span><span>${esc(row.language.toUpperCase())}</span>${row.viewport ? `<span>${esc(row.viewport)}</span>` : ""}</div><label>${text("state")}<select class="field" data-owner-status="${row.id}">${["open", "reviewed", "resolved"].map((status) => `<option value="${status}" ${status === row.status ? "selected" : ""}>${text(status)}</option>`).join("")}</select></label></div></details>`,
          )
          .join("")
      : empty("noneReports", "check", "reportEmpty");
    find("[data-reports-more]").hidden = !reportNext;
  }
  async function loadReports(append = false) {
    if (reportBusy) return;
    const version = ++reportVersion;
    const params = new URLSearchParams({
      status: find("[data-reports-filter]").value,
      q: find("[data-reports-search]").value,
    });
    if (append && reportNext) params.set("before", reportNext);
    find(".owner-reports").setAttribute("aria-busy", "true");
    find("[data-reports-more]").disabled = true;
    try {
      const result = await request(`/api/reports?${params}`);
      if (version !== reportVersion || !root.isConnected) return;
      reports = append ? [...reports, ...result.reports] : result.reports;
      reportNext = result.next;
      reportExpanded = append;
      find("[data-reports-total]").textContent = result.total;
      error("[data-reports-error]");
      drawReports();
    } catch (failure) {
      if (!controller.signal.aborted && version === reportVersion)
        error("[data-reports-error]", "error");
    } finally {
      if (version === reportVersion) {
        find(".owner-reports").removeAttribute("aria-busy");
        find("[data-reports-more]").disabled = false;
      }
    }
  }
  async function loadHistory(append = false) {
    if (historyBusy) return;
    historyBusy = true;
    find("[data-history-more]").disabled = true;
    try {
      const result = await request(
        "/api/owner/history" +
          (append && visitNext ? `?before=${visitNext}` : ""),
      );
      if (!root.isConnected) return;
      const firstLoad = !visits.length;
      const overlap = result.visits.some((row) =>
        visits.some((previous) => previous.id === row.id),
      );
      visits = [
        ...new Map(
          [...visits, ...result.visits].map((row) => [row.id, row]),
        ).values(),
      ].sort((a, b) => b.id - a.id);
      if (append || firstLoad) visitNext = result.next;
      // If many visits arrived between polls, reset to the latest contiguous page.
      else if (result.next && !overlap) {
        visits = result.visits;
        visitNext = result.next;
      }
      find("[data-history-list]").innerHTML = visits.length
        ? visits
            .map(
              (row) =>
                `<li><span class="owner-history-icon">${icon(row.email ? "people" : "globe")}</span><div><strong>${esc(row.email || text("guest"))}</strong><span>${text(row.method)} <small>· ${esc(row.page)}</small></span></div><time>${stamp(row.createdAt)}</time></li>`,
            )
            .join("")
        : `<li>${empty("noneHistory", "clock")}</li>`;
      find("[data-history-more]").hidden = !visitNext;
      error("[data-history-error]");
    } catch (failure) {
      if (!controller.signal.aborted) error("[data-history-error]", "error");
    } finally {
      historyBusy = false;
      find("[data-history-more]").disabled = false;
    }
  }
  find("[data-owner-refresh]").onclick = async () => {
    const button = find("[data-owner-refresh]");
    button.disabled = true;
    await Promise.all([loadPeople(), loadReports(), loadHistory()]);
    button.disabled = false;
  };
  root.querySelectorAll("[data-people-filter]").forEach((button) => {
    button.onclick = () => {
      peopleOnline = button.dataset.peopleFilter === "online";
      peoplePage = 1;
      root
        .querySelectorAll("[data-people-filter]")
        .forEach((el) =>
          el.setAttribute("aria-pressed", String(el === button)),
        );
      loadPeople();
    };
  });
  find("[data-people-search]").oninput = () => {
    clearTimeout(peopleDebounce);
    peopleVersion++;
    peoplePage = 1;
    peopleDebounce = setTimeout(loadPeople, 300);
  };
  find("[data-people-prev]").onclick = () => {
    peoplePage--;
    loadPeople();
  };
  find("[data-people-next]").onclick = () => {
    peoplePage++;
    loadPeople();
  };
  find("[data-reports-search]").oninput = () => {
    clearTimeout(reportDebounce);
    reportVersion++;
    reportDebounce = setTimeout(() => loadReports(), 300);
  };
  find("[data-reports-filter]").onchange = () => loadReports();
  find("[data-reports-more]").onclick = () => loadReports(true);
  find("[data-history-more]").onclick = () => loadHistory(true);
  find("[data-people-list]").onclick = (event) => {
    const button = event.target.closest("[data-user-reports]");
    if (!button) return;
    find("[data-reports-search]").value = button.dataset.userReports;
    find("[data-reports-filter]").value = "";
    loadReports();
    find(".owner-reports").scrollIntoView({
      behavior: matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "instant"
        : "smooth",
      block: "start",
    });
  };
  find("[data-reports-list]").onchange = async (event) => {
    const select = event.target.closest("[data-owner-status]");
    if (!select || reportBusy) return;
    const row = reports.find((row) => row.id === select.dataset.ownerStatus);
    const previous = row.status;
    root.querySelectorAll("[data-owner-status]").forEach((el) => {
      el.disabled = true;
    });
    reportVersion++;
    reportBusy = true;
    error("[data-reports-error]");
    find("[data-reports-feedback]").textContent = "";
    try {
      const result = await request(`/api/reports/${row.id}`, {
        method: "PATCH",
        data: { status: select.value },
      });
      Object.assign(row, result.report);
      reportBusy = false;
      drawReports();
      find(`[data-owner-status="${row.id}"]`)?.focus({ preventScroll: true });
      find("[data-reports-feedback]").textContent = text("saved");
      if (
        find("[data-reports-filter]").value &&
        find("[data-reports-filter]").value !== row.status
      )
        await loadReports();
      loadPeople();
    } catch (failure) {
      select.value = previous;
      if (!controller.signal.aborted)
        error("[data-reports-error]", "saveError");
    } finally {
      select.disabled = false;
      root.querySelectorAll("[data-owner-status]").forEach((el) => {
        el.disabled = false;
      });
      reportBusy = false;
    }
  };
  loadPeople();
  loadReports();
  loadHistory();
  let ticks = 0;
  const interval = setInterval(() => {
    if (!root.isConnected || !isOwner()) {
      dispose();
      return;
    }
    if (document.visibilityState !== "visible") return;
    loadPeople();
    loadHistory();
    if (
      ++ticks % 2 === 0 &&
      !reportBusy &&
      !reportExpanded &&
      !find("[data-reports-list]").contains(document.activeElement)
    )
      loadReports();
  }, 15_000);
  dispose = () => {
    controller.abort();
    clearInterval(interval);
    clearTimeout(peopleDebounce);
    clearTimeout(reportDebounce);
  };
}
